import React, { useEffect, Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { getMediaPath, reactParserCommonOptions } from '../../app/functions';

//components
import Breadrumbs from '../../components/common/bread_crumbs';

//assets
import './content.scss';

//routes
import * as routes from '../../constants/routes';

//actions
import ImageHeader from "../../components/image-header";
import { useGetPageByIdQuery } from '../../redux/api/content.api';

const findPageByPageKeyAndContentRoutes = (pageKey, contentRoutes) => {
    return contentRoutes.find(item => {
        return item.title === pageKey;
    });
}
function Content(props) {
    const deviceState = useSelector(store => store.state.deviceState);
    const text = useSelector(store => store.config.Translations);
    const contentRoutes = useSelector(store => store.config.ContentUrl);

    const pageId = findPageByPageKeyAndContentRoutes(props.location.pathname.replace('/', ''), contentRoutes);
    
    const id = pageId.id;

    const { data: contentPageData } = useGetPageByIdQuery(id);
    const [contentPage, setContentPage] = useState(contentPageData);
    const [bannerImg, setBannerImg] = useState(null);
    const [desktopBannerImg, setDesktopBannerImg] = useState(null);

    useEffect(() => {
        setContentPage(contentPageData);
        setBannerImg(contentPageData?.bannerImg);
        setDesktopBannerImg(contentPageData?.bannerImgDesktop);
    }, [contentPageData]);




    const isMobileOrTablet = deviceState === 'mobile' || deviceState === 'tablet';

    return (
        <section className='content-page'>
            {contentPage &&
                <Fragment>
                    {!contentPage?.hide_title &&
                        <ImageHeader
                            image={isMobileOrTablet ? (contentPage?.mobile_banner ? getMediaPath(contentPage?.mobile_banner) : null) : (contentPage?.desktop_banner ? getMediaPath(contentPage?.desktop_banner) : null)}
                            title={contentPage.title}
                        />
                    }
                    <Breadrumbs root={{ text: 'דף הבית', route: routes.home }} className="bread-crumbs" />

                    <div className='data-container'>
                        <div className='data-wrapper'>
                            <div className='para'>
                                {ReactHtmlParser(contentPage.content, reactParserCommonOptions())}
                            </div>
                        </div>
                    </div>
                </Fragment>
            }
        </section>
    );
}

export default Content;
